import {onLoaded, onMounted, onPageShowCached} from "./utilities/hooks";
import useStickyHeader from "./components/StickyHeader";
import useBillboard from "./components/Billboard";
import useModal from "./components/Modal";
import useTab from "./components/Tab";
import useHeaderColor from "./components/HeaderColor";
import useSearch from "./components/Search";
import defineSpinnerElement from "./WebComponents/Spinner";
import useCounterUpAnimator from "./utilities/CounterAnimator";
import useNavDropdown from "./components/NavDropdown";
import useCarousels from "./components/Carousel";
import useRouterActive from "./router/RouterActive";
import {routerTransition} from "./router/RouterTransition";
import mailchimp from "./mailchimp";
import animations from "./animations";
import defineBurgerElement from "./WebComponents/Burger";
import defineCollapseElement from "./WebComponents/Collapse";
import useTableHelper from "./components/TableHelper";
import {Store} from "./store";
import authProvider from "./service/AuthProvider";
import ScrollSpy from "./components/ScrollSpy";
import useForm from "./components/Forms";
// import vh100 from "./vh100";
// import lazyLoadImages from "./lazyload";


onMounted(async () => {
    Store.commit({lang: document.documentElement.lang});
    authProvider.init();
    // vh100.init();
    // lazyLoadImages.init();
    mailchimp.init();
    // Web Components
    defineBurgerElement();
    defineCollapseElement();
    defineSpinnerElement();
    useStickyHeader();
    useCounterUpAnimator();
    useBillboard();
    useModal();
    useTab();
    useHeaderColor();
    useSearch();
    useRouterActive();
    useNavDropdown();
    routerTransition.enter({
        onEnterEnd: () => {
            animations.init();
            useCarousels();
            new ScrollSpy(document.querySelector('[data-spy="scroll"]'));
        }
    })
});

onLoaded(() => {
    document.body.classList.add('loaded');
    console.log('loaded');
    useTableHelper();
    useForm();
});

onPageShowCached(() => {
    console.log('onPageShowCached:::');
    routerTransition.enter({
        onEnterEnd: () => {
            animations.init();
            useCarousels();
        }
    })
});

// onPageHideCached(() => {
//     console.log('onPageHideCached:::');
//     routerTransition.leave({
//         onLeaveEnd: () => {
//             routerTransition.enter({
//                 onEnterEnd: () => {
//                     animations.init();
//                     useCarousels();
//                 }
//             })
//         }
//     })
// });
